<template>
  <span v-if="Object.keys(eventsRefined).length > 0">
    <article
      v-bind:key="event.name"
      v-on:click="openModal(event)"
      class="article media"
      v-for="event in eventsRefined"
    >
      <figure class="media-left">
        <p class="image is-64x64">
          <img src="https://bulma.io/images/placeholders/128x128.png" />
        </p>
      </figure>
      <div class="media-content">
        <i
          class="material-icons is-pulled-right"
          v-bind:class="event.error ? `has-text-danger` : `has-text-success`"
          >{{ event.error ? "error" : "done" }}</i
        >
        <div class="content">
          <p>
            <strong>{{ event.title }}</strong>
            <br />
            {{ event.text }}
          </p>
        </div>
      </div>
    </article>
  </span>
  <div v-else>
    <b-message type="is-info">
      We haven't had an event with this company yet. Let's change that!
    </b-message>
  </div>
</template>

<script>
import store from "@/store/store";
import EditEvent from "@/components/app/event/EditEvent";

export default {
  props: ["isAdmin", "closeModal", "company_key"],
  methods: {
    openModal(data) {
      this.$modal.open({
        parent: this,
        component: EditEvent,
        props: { content: { ...data }, type: "event" },
        hasModalCard: true,
      });
    },
  },
  computed: {
    eventsRefined() {
      const letterCount = this.isAdmin ? 40 : 120;
      if (this.isAdmin) {
        const { events } = store.state.admin.events;
        const newEvents = Object.keys(events).map((d) => {
          const event = events[d];
          if (event.owner_key === this.company_key) {
            return { ...event, text: `${event.text.slice(0, letterCount)}...` };
          }
        });
        return newEvents.filter((event) => event !== undefined);
      } else {
        const events = store.getters["app/getEvents"];
        if (events) {
          Object.keys(events).forEach((d) => {
            const event = events[d];
            if (event.text.length > letterCount) {
              events[d] = {
                ...event,
                text: `${event.text.slice(0, letterCount)}...`,
              };
            }
          });
        }
        return events;
      }
    },
  },
};
</script>
<style scoped>
.article {
  margin-top: 25px;
  padding-top: 10px;
  transition: transform 0.2s;
}

.article:hover {
  transform: scale(1.03);
  cursor: pointer;
}
</style>
